export const ticketsSearchActions = {
    RESET_SEARCH_TICKETS: 'TICKETS_SEARCH/RESET_SEARCH_TICKETS'
};

export const resetSearchTickets = () => {
    return {
        type: ticketsSearchActions.RESET_SEARCH_TICKETS
    }
}